import React from "react";

import { OuterContainer, LogoWrapper } from "./styled-components";
import Logo from "../../_static/Logos";

const OnfidoPageRegistrationTemplate = (props) => {
  const { children, device, brand } = props;

  return (
    <OuterContainer data-qa-label="onfido-outer-container">
      <LogoWrapper device={device}>
        <Logo
          brand={brand}
          height={device === "mobile" ? 20 : 25}
          data-qa-label="tvg-logo"
        />
      </LogoWrapper>
      {children}
    </OuterContainer>
  );
};

OnfidoPageRegistrationTemplate.defaultProps = {
  device: "mobile",
  brand: "tvg"
};

export default OnfidoPageRegistrationTemplate;
